import {
  UI_COLOR_AVATAR_NEUTRAL_BG,
  UI_COLOR_BLACK,
  UI_COLOR_BORDER_DIALOG_DIVIDER,
  UI_COLOR_BORDER_DIVIDER_SOFT,
  UI_COLOR_BORDER_FORM_CARD,
  UI_COLOR_BORDER_INPUT_HOVER_ALT,
  UI_COLOR_BORDER_SURVEY_SELECTOR,
  UI_COLOR_BORDER_UTILITY_DISABLED,
  UI_COLOR_BUTTON_MUTED,
  UI_COLOR_ERROR_MATERIAL,
  UI_COLOR_ERROR_MATERIAL_BG,
  UI_COLOR_ICON_CHEVRON,
  UI_COLOR_ICON_GRAY,
  UI_COLOR_PRIMARY,
  UI_COLOR_RBAC_STATUS_PENDING_BG,
  UI_COLOR_SHADOW_DIALOG,
  UI_COLOR_TEXT_DIALOG_BODY,
  UI_COLOR_TEXT_DIALOG_FIELD_LABEL,
  UI_COLOR_TEXT_DIALOG_META,
  UI_COLOR_TEXT_DIALOG_SUBTITLE,
  UI_COLOR_TEXT_DIALOG_TITLE,
  UI_COLOR_TEXT_PLACEHOLDER,
  UI_COLOR_TEXT_WARM,
  UI_COLOR_TRANSPARENT,
  UI_COLOR_WARNING_ACCENT,
  UI_COLOR_WHITE
} from './uiColors'

export function getDialogPaperSx(maxWidth = 520, extra = {}) {
  return {
    width: { xs: 'calc(100% - 32px)', sm: maxWidth },
    maxWidth,
    borderRadius: '8px',
    boxShadow: UI_COLOR_SHADOW_DIALOG,
    ...extra
  }
}

export const dialogTitleSx = {
  color: UI_COLOR_TEXT_DIALOG_TITLE,
  fontSize: 18,
  fontWeight: 700,
  lineHeight: 1.3
}

export const dialogSubtitleSx = {
  color: UI_COLOR_TEXT_DIALOG_SUBTITLE,
  fontSize: 13,
  lineHeight: 1.4,
  mt: 0.5
}

export const dialogHeaderSx = {
  px: { xs: 2.5, sm: 3 },
  pt: 2.5,
  pb: 1.5
}

export const dialogHeaderWithSubtitleSx = {
  px: { xs: 2.5, sm: 3 },
  pt: 2.5,
  pb: 1.75
}

export const dialogDividerSx = {
  mb: 2,
  borderColor: UI_COLOR_BORDER_DIALOG_DIVIDER,
  borderBottomWidth: 1
}

export const dialogDividerCompactSx = {
  mb: 1,
  borderColor: UI_COLOR_BORDER_DIALOG_DIVIDER,
  borderBottomWidth: 1
}

export const dialogContentSx = {
  px: { xs: 2.5, sm: 3 },
  pt: '0 !important',
  pb: 1
}

export const dialogContentWithBorderSx = {
  borderTop: `1px solid ${UI_COLOR_BORDER_DIVIDER_SOFT}`,
  px: { xs: 2.5, sm: 3 },
  pt: '20px !important',
  pb: 1
}

export const dialogActionsSx = {
  px: { xs: 2.5, sm: 3 },
  py: 2
}

export const dialogActionsSpacedSx = {
  px: { xs: 2.5, sm: 3 },
  py: 2,
  mt: 1
}

export const dialogActionsWithMetaSx = {
  px: { xs: 2.5, sm: 3 },
  py: 2,
  mt: 1,
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 2,
  flexWrap: 'wrap'
}

export const dialogBodyTextSx = {
  color: UI_COLOR_TEXT_DIALOG_BODY,
  fontSize: 14,
  lineHeight: 1.5,
  mb: 2
}

export const dialogErrorTextSx = {
  color: UI_COLOR_ERROR_MATERIAL,
  fontSize: 13,
  mt: 1.5
}

export const dialogSelectedCountSx = {
  color: UI_COLOR_TEXT_DIALOG_META,
  fontSize: 13,
  fontWeight: 500
}

export const dialogEmptyStateTextSx = {
  color: UI_COLOR_TEXT_DIALOG_SUBTITLE,
  fontSize: 12
}

export const dialogSearchIconSx = {
  color: UI_COLOR_TEXT_PLACEHOLDER,
  fontSize: 20
}

export const dialogAvatarSx = {
  bgcolor: UI_COLOR_AVATAR_NEUTRAL_BG,
  color: UI_COLOR_TEXT_DIALOG_META,
  fontSize: 14,
  fontWeight: 700
}

export const dialogAvatarCompactSx = {
  width: 36,
  height: 36,
  bgcolor: UI_COLOR_AVATAR_NEUTRAL_BG,
  color: UI_COLOR_TEXT_DIALOG_META,
  fontSize: 13,
  fontWeight: 700
}

export const dialogConfirmCardSx = {
  border: `1px solid ${UI_COLOR_BORDER_UTILITY_DISABLED}`,
  borderRadius: '8px',
  p: 1.5
}

export const dialogConfirmUserCardSx = {
  border: `1px solid ${UI_COLOR_BORDER_UTILITY_DISABLED}`,
  borderRadius: '8px',
  p: 1.5,
  display: 'flex',
  gap: 1.5,
  alignItems: 'center'
}

export const dialogFormCardSx = {
  border: `1px solid ${UI_COLOR_BORDER_FORM_CARD}`,
  borderRadius: '8px',
  px: { xs: 2, sm: 2.5 },
  py: 2.5,
  mt: 2
}

export const dialogUserCardSx = {
  border: `1px solid ${UI_COLOR_BORDER_FORM_CARD}`,
  borderRadius: '8px',
  px: 1.75,
  py: 1.5,
  display: 'flex',
  alignItems: 'center',
  gap: 1.5
}

export const dialogFieldLabelSx = {
  display: 'block',
  mb: 0.75,
  color: UI_COLOR_TEXT_DIALOG_FIELD_LABEL,
  fontSize: 13,
  fontWeight: 700,
  lineHeight: '18px'
}

export const dialogRequiredMarkSx = {
  color: UI_COLOR_ERROR_MATERIAL,
  fontWeight: 700
}

export const dialogActionButtonSx = {
  fontWeight: 500
}

export const dialogNameTextSx = {
  fontWeight: 700,
  color: UI_COLOR_TEXT_DIALOG_TITLE,
  fontSize: 14,
  lineHeight: 1.3,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}

export const dialogEmailTextSx = {
  color: UI_COLOR_TEXT_DIALOG_SUBTITLE,
  fontSize: 12,
  lineHeight: 1.4,
  mt: 0.25,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}

export const dialogCurrentRoleLabelSx = {
  color: UI_COLOR_TEXT_PLACEHOLDER,
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: '0.4px',
  textTransform: 'uppercase'
}

export const dialogMetaTextSx = {
  color: UI_COLOR_TEXT_DIALOG_META,
  fontSize: 13,
  lineHeight: 1.4,
  mt: 0.25
}

export const dialogCheckboxSx = {
  p: 0.5,
  color: UI_COLOR_ICON_CHEVRON,
  '&.Mui-checked': { color: UI_COLOR_PRIMARY }
}

export const dialogSearchFieldSx = {
  '& .MuiOutlinedInput-root': {
    minHeight: 40,
    borderRadius: '6px',
    backgroundColor: UI_COLOR_WHITE,
    alignItems: 'center',
    '& fieldset': {
      borderColor: UI_COLOR_BORDER_SURVEY_SELECTOR
    },
    '&:hover fieldset': {
      borderColor: UI_COLOR_BORDER_INPUT_HOVER_ALT
    },
    '&.Mui-focused fieldset': {
      borderColor: UI_COLOR_PRIMARY,
      borderWidth: '1px'
    }
  },
  '& .MuiInputBase-input': {
    px: 1.5,
    py: 1,
    fontSize: 14,
    lineHeight: 1.4,
    '&::placeholder': {
      color: UI_COLOR_TEXT_PLACEHOLDER,
      opacity: 1
    }
  },
  '& .MuiInputLabel-root': {
    display: 'none'
  },
  '& .MuiAutocomplete-inputRoot': {
    minHeight: 40,
    py: 0,
    pl: 1.25
  },
  '& .MuiAutocomplete-clearIndicator': {
    color: UI_COLOR_TEXT_PLACEHOLDER,
    backgroundColor: `${UI_COLOR_TRANSPARENT} !important`
  },
  '& .MuiAutocomplete-clearIndicator:hover': {
    backgroundColor: `${UI_COLOR_TRANSPARENT} !important`,
    color: UI_COLOR_TEXT_PLACEHOLDER
  },
  '& .MuiAutocomplete-popupIndicator': {
    color: UI_COLOR_TEXT_PLACEHOLDER,
    backgroundColor: `${UI_COLOR_TRANSPARENT} !important`
  },
  '& .MuiAutocomplete-popupIndicator:hover': {
    backgroundColor: `${UI_COLOR_TRANSPARENT} !important`,
    color: UI_COLOR_TEXT_PLACEHOLDER
  },
  '& .MuiAutocomplete-input': {
    py: '0 !important'
  }
}

export const guidanceNoteErrorColors = {
  accentColor: UI_COLOR_ERROR_MATERIAL,
  backgroundColor: UI_COLOR_ERROR_MATERIAL_BG,
  textColor: UI_COLOR_TEXT_WARM
}

export const guidanceNoteErrorSx = {
  border: 0,
  borderLeft: `4px solid ${UI_COLOR_ERROR_MATERIAL}`,
  borderRadius: '6px',
  mb: 2,
  px: { xs: 1.5, sm: 1.75 },
  py: 1.25
}

export const guidanceNoteErrorHeaderSx = {
  alignItems: 'flex-start',
  flexWrap: 'nowrap',
  columnGap: 0.5
}

export const guidanceNoteIconSx = {
  mt: 0.15,
  mr: 0,
  ml: 0,
  '& svg': {
    fontSize: 18
  }
}

export const guidanceNoteErrorTitleSx = {
  display: 'block',
  color: UI_COLOR_TEXT_WARM,
  fontSize: 13,
  fontWeight: 700
}

export const guidanceNoteErrorMessageSx = {
  color: UI_COLOR_TEXT_WARM,
  fontSize: 13,
  fontWeight: 400,
  lineHeight: 1.45
}

export const guidanceNoteWarningColors = {
  accentColor: UI_COLOR_WARNING_ACCENT,
  backgroundColor: UI_COLOR_RBAC_STATUS_PENDING_BG,
  textColor: UI_COLOR_WARNING_ACCENT
}

export const guidanceNoteWarningSx = {
  border: 0,
  borderLeft: `4px solid ${UI_COLOR_WARNING_ACCENT}`,
  borderRadius: '6px',
  mb: 2,
  px: { xs: 1.5, sm: 1.75 },
  py: 1.25
}

export const guidanceNoteWarningHeaderSx = {
  alignItems: 'flex-start',
  flexWrap: 'nowrap',
  columnGap: 1
}

export const guidanceNoteWarningMessageSx = {
  color: UI_COLOR_BLACK,
  fontSize: 13,
  fontWeight: 400,
  lineHeight: 1.45
}

export const guidanceNoteWarningAccentColors = {
  accentColor: UI_COLOR_WARNING_ACCENT,
  backgroundColor: UI_COLOR_RBAC_STATUS_PENDING_BG,
  textColor: UI_COLOR_WARNING_ACCENT
}

export const guidanceNoteWarningAccentMessageSx = {
  color: UI_COLOR_WARNING_ACCENT,
  fontSize: 13,
  fontWeight: 400,
  lineHeight: 1.45
}

export const createUserDialogSubtitleSx = {
  mt: '4px !important',
  color: `${UI_COLOR_ICON_GRAY} !important`,
  fontSize: '13px !important',
  lineHeight: '1.4 !important'
}

export function getDialogCancelAction({ onClick, disabled, label = 'Cancelar', sx } = {}) {
  return {
    label,
    icon: null,
    color: UI_COLOR_BUTTON_MUTED,
    hoverColor: UI_COLOR_BUTTON_MUTED,
    hoverBackgroundColor: UI_COLOR_WHITE,
    hoverTextColor: UI_COLOR_BUTTON_MUTED,
    onClick,
    disabled,
    ...(sx ? { sx } : {})
  }
}
